// src/utils/clientId.js
export const CLIENT_ID_KEY = "qubiq_client_id";

export function getClientId() {
  if (typeof window === "undefined") return "";
  let cid = localStorage.getItem(CLIENT_ID_KEY);
  if (!cid) {
    cid = window.crypto?.randomUUID?.() || `qubiq_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(CLIENT_ID_KEY, cid);
  }
  return cid;
}
